/** @format */

export const localProductMenuData = [
  {
    productType: 0,
    childType: 0,
    title: '云主机',
    screenName: 'kvmdefault',
    link: '/monitor/list/kec',
    subMenus: []
  },
  {
    productType: 43,
    childType: 43,
    title: 'GPU裸金属服务器',
    screenName: 'epcgpu',
    link: '/monitor/list/epcgpu',
    subMenus: []
  },
  {
    productType: 69,
    childType: 70,
    title: '容器实例',
    screenName: '',
    link: '/monitor/list/KCI',
    subMenus: []
  },
  {
    productType: 21,
    childType: 21,
    title: 'GPU云服务器',
    screenName: 'gpudefault',
    link: '/monitor/list/gpu',
    subMenus: []
  },
  {
    productType: 15,
    childType: 15,
    title: '裸金属服务器',
    screenName: 'epcdefault',
    link: '/monitor/list/epc',
    subMenus: []
  },
  {
    productType: 20,
    childType: 20,
    title: '专属宿主机',
    screenName: 'dedicatedhostdefault',
    link: '/monitor/list/dedicatedhost',
    subMenus: []
  },
  {
    productType: 78,
    childType: 78,
    title: 'vGPU',
    screenName: 'QA-VGPU',
    link: '/monitor/list/vGPU',
    subMenus: []
  },
  {
    productType: 28,
    childType: 28,
    title: '容器引擎-集群',
    screenName: 'kcecluster',
    link: '/monitor/list/kcecluster',
    subMenus: []
  },
  {
    productType: 1,
    childType: 1,
    title: '对象存储',
    screenName: 'ks3',
    link: '/monitor/list/ks3',
    subMenus: []
  },
  {
    productType: 2,
    childType: 2,
    title: '关系型数据库',
    screenName: 'krdsdefault',
    link: '/monitor/list/krds',
    subMenus: []
  },
  {
    productType: 3,
    childType: 3,
    title: '表格数据库',
    screenName: 'ktsdefault',
    link: '/monitor/list/kts',
    subMenus: []
  },
  {
    productType: 4,
    childType: 4,
    title: '弹性IP',
    screenName: 'eipdefault',
    link: '/monitor/list/eip',
    subMenus: []
  },
  {
    productType: 7,
    childType: 7,
    title: '负载均衡',
    screenName: 'lbdefault',
    link: '/monitor/list/slb',
    subMenus: []
  },
  {
    productType: 10,
    childType: 10,
    title: 'NAT',
    screenName: 'innernatdefault',
    link: '/monitor/list/nat',
    subMenus: []
  },
  {
    productType: 11,
    childType: 11,
    title: '共享带宽',
    screenName: 'sgwdefault',
    link: '/monitor/list/bws',
    subMenus: []
  },
  {
    productType: 12,
    childType: 48,
    title: '高防IP',
    screenName: 'KAD-Instance',
    link: '/monitor/list/kad',
    subMenus: []
  },
  {
    productType: 13,
    childType: 13,
    title: '云数据库MongoDB',
    screenName: 'mongodbdefault',
    link: '/monitor/list/mongodb',
    subMenus: [
      {
        productType: 50,
        childType: 50,
        title: 'MongoDB分片集群-实例',
        screenName: '',
        link: '',
        subMenus: []
      },
      {
        productType: 56,
        childType: 56,
        title: 'MongoDB副本集-实例',
        screenName: 'MongoRepSet-Node',
        link: '',
        subMenus: []
      }
    ]
  },
  {
    productType: 16,
    childType: 16,
    title: '对等连接',
    screenName: 'peeringdefault',
    link: '/monitor/list/peering',
    subMenus: []
  },
  {
    productType: 17,
    childType: 17,
    title: '专线网关',
    screenName: 'dcgwdefault',
    link: '/monitor/list/dcgw',
    subMenus: []
  },
  {
    productType: 22,
    childType: 22,
    title: 'CDN',
    screenName: 'cdndefault',
    link: '/monitor/list/cdn',
    subMenus: []
  },
  {
    productType: 24,
    childType: 24,
    title: 'HTTP型监听器',
    screenName: 'listenerhttp',
    link: '/monitor/list/listenerhttp',
    subMenus: []
  },
  {
    productType: 25,
    childType: 25,
    title: 'TCP型监听器',
    screenName: 'listenertcp',
    link: '/monitor/list/listenertcp',
    subMenus: []
  },
  {
    productType: 26,
    childType: 26,
    title: 'HTTPS型监听器',
    screenName: 'listenerhttps',
    link: '/monitor/list/listenerhttps',
    subMenus: []
  },
  {
    productType: 27,
    childType: 27,
    title: 'UDP型监听器',
    screenName: 'listenerudp',
    link: '/monitor/list/listenerudp',
    subMenus: []
  },
  {
    productType: 38,
    childType: 38,
    title: 'Memcached',
    screenName: 'memcached',
    link: '/monitor/list/memcached',
    subMenus: []
  },
  {
    productType: 39,
    childType: 39,
    title: '分布式数据库',
    screenName: 'drdsdefault',
    link: '/monitor/list/drds',
    subMenus: []
  },
  {
    productType: 42,
    childType: 42,
    title: '云数据库PostgreSQL',
    screenName: 'postgresql',
    link: '/monitor/list/postgresql',
    subMenus: []
  },
  {
    productType: 44,
    childType: 44,
    title: 'SQL Server',
    screenName: 'sqlserver',
    link: '/monitor/list/sqlserver',
    subMenus: []
  },
  {
    productType: 46,
    childType: 46,
    title: '数据传输服务',
    screenName: 'KDTS',
    link: '/monitor/list/kdts',
    subMenus: []
  },
  {
    productType: 61,
    childType: 61,
    title: 'InfluxDB',
    screenName: 'InfluxDB',
    link: '/monitor/list/InfluxDB',
    subMenus: []
  },
  {
    productType: 66,
    childType: 67,
    title: 'RabbitMQ',
    screenName: '',
    link: '/monitor/list/RabbitMQ',
    subMenus: []
  },
  {
    productType: 72,
    childType: 73,
    title: 'Elasticsearch服务',
    screenName: '',
    link: '/monitor/list/KES',
    subMenus: []
  },
  {
    productType: 79,
    childType: 79,
    title: 'KingDB',
    screenName: 'KingDB',
    link: '/monitor/list/KingDB',
    subMenus: []
  },
  {
    productType: 80,
    childType: 81,
    title: 'WAF',
    screenName: '',
    link: '/monitor/list/waf',
    subMenus: []
  },
  {
    productType: 83,
    childType: 84,
    title: 'HBase服务',
    screenName: '',
    link: '/monitor/list/KHBase',
    subMenus: []
  },
  {
    productType: 94,
    childType: 94,
    title: '文件存储KPFS',
    screenName: 'KPFS',
    link: '/monitor/list/KPFS',
    subMenus: []
  },
  {
    productType: 95,
    childType: 95,
    title: 'ClickHouse',
    screenName: 'ClickHouse',
    link: '/monitor/list/ClickHouse',
    subMenus: []
  },
  {
    productType: 96,
    childType: 96,
    title: 'TiDB',
    screenName: 'TiDB',
    link: '/monitor/list/TiDB',
    subMenus: []
  },
  {
    productType: 97,
    childType: 97,
    title: '云数据库Redis-主从版',
    screenName: 'RedisSdn-Console',
    link: '/monitor/list/RedisSdn-Console',
    subMenus: []
  },
  {
    productType: 99,
    childType: 99,
    title: '云数据库Redis-集群版',
    screenName: 'RedisCluster-Console',
    link: '/monitor/list/RedisCluster-Console',
    subMenus: []
  },
  {
    productType: 104,
    childType: 104,
    title: 'KMR集群',
    screenName: 'KMRCluster',
    link: '/monitor/list/KMRCluster',
    subMenus: []
  },
  {
    productType: 105,
    childType: 105,
    title: 'KMR节点',
    screenName: 'kmrnode',
    link: '/monitor/list/KMRNode',
    subMenus: []
  },
  {
    productType: 109,
    childType: 109,
    title: '云数据库Cassandra',
    screenName: '',
    link: '/monitor/list/Cassandra',
    subMenus: []
  },
  {
    productType: 111,
    childType: 111,
    title: '高速通道',
    screenName: 'kistunneldefault',
    link: '/monitor/list/kistunneldefault',
    subMenus: []
  },
  {
    productType: 112,
    childType: 112,
    title: 'VPC互通',
    screenName: 'kisvpcdefault',
    link: '/monitor/list/kisvpcdefault',
    subMenus: []
  },
  {
    productType: 113,
    childType: 113,
    title: '通道端口',
    screenName: 'kisportdefault',
    link: '/monitor/list/kisportdefault',
    subMenus: []
  },
  {
    productType: 107,
    childType: 107,
    title: 'WAF 3.0',
    screenName: '',
    link: '/monitor/list/waf3',
    subMenus: []
  },
  {
    productType: 150,
    childType: 150,
    title: 'ks3-accelerate',
    screenName: 'ks3-accelerate',
    link: '/monitor/list/ks3-accelerate',
    subMenus: []
  }
]
